import { ForwardedRef, forwardRef } from 'react';

import AgGridDatepickerTag4Editor, {
  AgGridDatepickerTag4EditorReference,
  HandleChangeDate,
  IAgGridDatepickerTag4EditorProps
} from '@/components/common/TableGrid/CustomComponents/AgGridDatepicker/AgGridDatepickerTag4Editor';

interface IProRataEndDateEditorProps extends IAgGridDatepickerTag4EditorProps {
}

function ProRataEndDateEditor(
  props: IProRataEndDateEditorProps,
  passRefToGrid: ForwardedRef<AgGridDatepickerTag4EditorReference>
) {
  const { handleChangeDate, ...restProps } = props;

  const handleCustomChangeDate: HandleChangeDate = (selectedDate, applyChanges) => {
    applyChanges(selectedDate);
  };

  return (
    <>
      <AgGridDatepickerTag4Editor
        ref={passRefToGrid}
        handleChangeDate={handleCustomChangeDate}
        {...restProps}
      />
    </>
  );
}

export default forwardRef(ProRataEndDateEditor);
